import React from 'react'
import DepartEditContainer from '../../containers/deptmng/DeptEditContainer'

const DeptEditPage = () => {
  return <DepartEditContainer/>
}

export default DeptEditPage